<script setup lang="ts">
const items = [
  {
    title: 'Notifikasi Cepat & Real Time',
    description:
      'Dapatkan alert otomatis setiap kali ada paket gagal kirim. Tidak perlu cek manual, sistem kami yang memantau untukmu.',
    icon: 'material-symbols:history-toggle-off'
  },
  {
    title: 'Tindakan Langsung dari Dashboard',
    description:
      'Kirim ulang, konfirmasi alamat, atau proses retur langsung dari dashboard — tanpa buka sistem lain.',
    icon: 'material-symbols:monitor-outline'
  },
  {
    title: 'Rekap Kasus Otomatis & Insight Gagal Kirim',
    description:
      'Lihat jumlah, penyebab, dan tren kasus dengan tampilan grafik yang mudah dibaca.',
    icon: 'material-symbols:description-outline'
  }
]
</script>

<template>
  <section class="bg-surface-container-low dark:bg-surface-container-highest">
    <UiContainer class="py-12 flex flex-col gap-6 lg:gap-16">
      <UiSectionTitle
        class="text-center"
        title="Solusi Undelivery KiriminAja"
        description="Satu dashboard untuk semua kendala pengiriman — dari notifikasi sampai tindakan langsung."
      />

      <div class="grid grid-cols-1 gap-6 lg:grid-cols-3">
        <UiCardFeature
          v-for="(item, key) in items"
          :key="key"
          :icon="item.icon"
          icon-size="32px"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </UiContainer>
  </section>
</template>
